import { EngineLiveIcon } from "design_system_radar/icons/EngineLiveIcon";
import { RadarLoader } from "design_system_radar/loaders/RadarLoader";

interface ReconciliationProgressProps {
  title: string;
  description: string;
  isRunning: boolean;
}

export function ReconciliationProgress({
  title,
  description,
  isRunning,
}: ReconciliationProgressProps) {
  return (
    <section
      className="flex w-full flex-col items-center px-6 py-10 text-center"
      aria-label="Estado de conciliación"
    >
      <div className="mb-6 flex size-20 items-center justify-center rounded-full border border-white/10 bg-[#1C1D26]">
        <EngineLiveIcon
          size={40}
          className="text-radar-120"
          animated={isRunning}
        />
      </div>
      <div aria-live="polite" className="w-full min-w-0">
        <h2 className="mb-4 text-2xl font-bold text-white">{title}</h2>
        <p className="mb-8 break-words text-sm leading-relaxed text-radar-120">
          {description}
        </p>
      </div>
      {isRunning && <RadarLoader />}
    </section>
  );
}
